const addTimezone = (date: Date) => {
  const timezone = new Date().getTimezoneOffset()
  const timezoneDate: Date | undefined = date && new Date(date.getTime() - timezone * 60000)
  return timezoneDate
}

export default addTimezone
